import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { useConversion } from 'hooks';
import messages from 'components/Charts/messages';
import * as selectors from 'modules/PatientResults/selectors';
import { getIsPlainValuesMode, getUnitSymbol } from './helpers';
const Average = ({ innerWidth, xScale, yScale, pointSize, pointBorderWidth, dataSerie, tickParts, getPointColor, getBorderColor })=>{
    const calculationFormula = useSelector(selectors.calculationFormula);
    const intl = useIntl();
    const conversion = useConversion('bloodGlucoseConcentration');
    const isPlainValuesMode = getIsPlainValuesMode(calculationFormula);
    const unitSymbol = isPlainValuesMode ? getUnitSymbol(calculationFormula) : conversion.unitSymbol;
    const color = getPointColor(dataSerie);
    const borderColor = getBorderColor(dataSerie);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: dataSerie.data.map((avg)=>{
            const timestamp = avg.x;
            const value = avg.y;
            const tickPart = tickParts.find((part)=>timestamp >= part.start && timestamp <= part.end);
            if (!tickPart) return null;
            const xPos = xScale(tickPart.start);
            const yPos = yScale(value);
            return /*#__PURE__*/ _jsxs("g", {
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        y: -pointSize / 4,
                        width: innerWidth * tickPart.width,
                        height: pointSize / 2,
                        fill: color,
                        stroke: borderColor,
                        strokeWidth: pointBorderWidth,
                        style: {
                            pointerEvents: 'none',
                            transform: `translate(${xPos}px, ${yPos}px )`
                        }
                    }),
                    /*#__PURE__*/ _jsx("text", {
                        x: "0",
                        y: "-5",
                        fontSize: "10",
                        fill: "black",
                        style: {
                            pointerEvents: 'none',
                            transform: `translate(${xPos}px, ${yPos}px )`
                        },
                        children: `${intl.formatMessage(messages.average)}: ${value} ${unitSymbol}`
                    })
                ]
            }, `avg-${timestamp}-${value}`);
        })
    });
};
export default Average;
